import * as _ from 'lodash'

import Component from 'vue-class-component'

import { AuditCampaignPopUp } from './audit-campaign-pop-up'
import { ItemEditScreen } from '@skinsoft/entity-ui/src/item/components/item-edit-screen'
import { OPEN_AUDIT_CAMPAIGN_POP_UP } from '../../../busTopics'
import { ReactiveVue } from '@skinsoft/reactive-vue'


@Component({
    components: {
        auditCampaignPopUp: AuditCampaignPopUp,
        sItemEditScreen: ItemEditScreen,
    },
    props: ['item', 'headerTitle', 'induceUpdate'],
    template: require('./audit-item-edit-screen.html')
})
export class AuditItemEditScreen extends ReactiveVue {
    private auditCampaignPopUp = false

    public mounted() {
        this.subscribeToBus(OPEN_AUDIT_CAMPAIGN_POP_UP, this.toggleAuditCampaignPopUp)
    }

    private toggleAuditCampaignPopUp() {
        this.auditCampaignPopUp = !this.auditCampaignPopUp
    }
}